export const TimeStampReducer = (state, action) => {
    if (action.type === "USER") {
        return { ...state, ...action.payload }
    }
    return state
}
